import {createEntityService} from 'utils/createEntityService';
import {HrDocument} from 'types/hrDocument';

export const HrDocumentService = createEntityService<HrDocument>({
  baseUrl: 'api/v1/hr_documents',
  entityName: 'hrDocument',
});
